import React, { Component } from 'react';
import { connect } from 'react-redux';
import queryString from 'query-string';
import moment from 'moment';

import Spinner from '../../components/generics/Spinner';
import DetailHeader from '../../components/generics/DetailHeader';
import SelectableInventoryTable from '../../components/generics/SelectableInventoryTable';
import GenericDropdown from '../../components/generics/GenericDropdown';

import {
  fetchShipment,
  fetchShipmentSuccess,
  fetchShipmentFailure,
  createReturn,
  createReturnSuccess,
  createReturnFailure,
  fetchReturnCategories,
  fetchReturnCategoriesSuccess,
  fetchReturnCategoriesFailure,
} from "../../store/shipments/actions";

import { getShipmentBoxes } from '../../store/shipments/api';

import Alert from '../../utils/Alert';
import { withRouter } from "utils/WithRouter";

export class ReturnDetailContainer extends Component {

  // ---------------------------------------------------------------------------
  // Initialization
  // ---------------------------------------------------------------------------
  constructor(props){
    super(props);

    this.state = {
      boxes: [],
      categoryIndex: -1,
      errors: [],
    };

    this.alertRef = React.createRef();
  };

  componentDidMount(){
    const params = queryString.parse(this.props.location.search);
    const selectedShipment = params.s ? params.s : undefined;

    this.props.fetchReturnCategories();

    if (selectedShipment){
      this.props.fetchShipment(selectedShipment);
    }
    // This call its performed outside the redux flow because its only used
    // in the context of this screen.
    getShipmentBoxes(selectedShipment).then((res) => {
      res.data.map((box) => {
        box.old = {price: box.price, number_items: box.number_items, weight: box.weight};
        return true;
      });
      this.setState({ boxes: res.data });
    }, () => {
      this.alertRef.current.sendAlert('Cannot load Invoice boxes');
    });
  }
  // ---------------------------------------------------------------------------
  // Credit Note handling
  // ---------------------------------------------------------------------------
  createReturn = () => {
    let category_id = this.props.returnCategoriesList.categories[this.state.categoryIndex] ? this.props.returnCategoriesList.categories[this.state.categoryIndex].id : '';
    // In case there are't any return categories yet
    if (!category_id && this.props.returnCategoriesList.categories.length > 0) {
      let errors = this.state.errors;
      if (errors.indexOf('category') === -1) {
        errors.push('category');
        this.setState(errors);
      }
      this.alertRef.current.sendAlert("You need to select a return category");
    } else {
      let selected = this.state.boxes.filter((b) => {
        return b.selected;
      });
      if (selected.length === 0) {
        this.alertRef.current.sendAlert("Select at least one inventory item to return");
      } else {
        // Remove frontend information
        selected.forEach((s)=>{
          delete s.old;
          delete s.in_return;
        });
        this.props.createReturn({
          shipment: this.props.createEditShipment.shipment.id,
          return_category: category_id,
          inventory_details: selected
        }, this.props, this.alertRef);
      }
    }
  };

  onInventorySelect = (event) => {
    const idx = event.target.value;
    let boxes = this.state.boxes;
    const newVal = boxes[idx].selected !== undefined ? !boxes[idx].selected : true;
    if (!newVal){
      boxes[idx].weight = boxes[idx].old.weight;
      boxes[idx].number_items = boxes[idx].old.number_items;
      boxes[idx].price = boxes[idx].old.price;
    }
    boxes[idx].selected = newVal;
    this.setState({ boxes });
  };

  updateWeight = (newVal, idx) => {
    let boxes = this.state.boxes;
    boxes[idx].weight = newVal;
    this.setState({ boxes });
  };

  updateNumberOfItems = (newVal, idx) => {
    let boxes = this.state.boxes;
    boxes[idx].number_items = newVal;
    this.setState({ boxes });
  };

  updatePrice = (newVal, idx) => {
    let boxes = this.state.boxes;
    boxes[idx].price = newVal;
    this.setState({ boxes });
  };

  spliceError = (element) => {
    var errors = this.state.errors.slice();
    var index = errors.indexOf(element);
    if(index !== -1){
      errors.splice(index, 1)
    }
    return errors
  };

  onSelectedCategoryChange = (event) => {
    let errors = [];
    if (event.target.value > -1) {
      errors = this.spliceError('category');
    } else {
      errors = this.state.errors;
      if (errors.indexOf('category') === -1) {
        errors.push('category');
      }
    }
    this.setState({ categoryIndex: event.target.value, errors });
  };

  // ---------------------------------------------------------------------------
  // Render
  // ---------------------------------------------------------------------------
  render(){
      if (!this.props.createEditShipment.shipment){
        return (
          <div>
            <Alert ref={this.alertRef}/>
            <Spinner />
          </div>
        );
      } else {
        return (
          <div className="animated fadeIn credit-note">
            <Alert ref={this.alertRef}/>
            <DetailHeader title="Issue Return"
                          actionTitle="Finish"
                          action={this.createReturn}
                          actionClass="btn btn-danger m-0"
                          actionIconClass="fa fa-check mr-05"
                          col1Title="Shipment ID"
                          col1Desc={this.props.createEditShipment.shipment.id}
                          col2Title="Shipment date"
                          col2Desc={moment(this.props.createEditShipment.shipment.creation_date).format('LLL')}
                          col3Title="Customer"
                          col3Desc={this.props.createEditShipment.shipment.destination.name}/>
            <GenericDropdown list={this.props.returnCategoriesList.categories}
                             value={this.state.categoryIndex}
                             onSelectChange={this.onSelectedCategoryChange}
                             text={'Category'}
                             emptySelectMsg={'Select return category'}
                             dropdownError={this.state.errors.indexOf('category') !== -1}/>
            <SelectableInventoryTable list={this.state.boxes}
                                      onSelect={this.onInventorySelect}
                                      updateWeight={this.updateWeight}
                                      updateNumberOfItems={this.updateNumberOfItems}
                                      updatePrice={this.updatePrice}
                                      tableTitle="Inventory items"
                                      isReturn={true}
                                      showCostPrice={true}
                                      smallHeaderSize={true}/>
          </div>
        );
      }
    }
  }

const mapStateToProps = (state, ownProps) => {
  return {
    createEditShipment: state.shipments.createEditShipment,
    returnCategoriesList: state.shipments.returnCategoriesList,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchShipment: (id) => {
      dispatch(fetchShipment(id)).payload.then((response) => {
        dispatch(fetchShipmentSuccess(response.data))
      }, (error) => {
        dispatch(fetchShipmentFailure(error));
      });
    },
    createReturn: (data, props, alertRef) => {
      dispatch(createReturn(data)).payload.then((response) => {
        dispatch(createReturnSuccess(response.data));
        alertRef.current.sendAlert("Return successfully issued", "success");
        props.history.push('/return/'+response.data.id);
      }, (error) => {
        dispatch(createReturnFailure(error));
      });
    },
    fetchReturnCategories: (props) => {
      dispatch(fetchReturnCategories()).payload.then((response) => {
        dispatch(fetchReturnCategoriesSuccess(response.data));
      }, (error) => {
        dispatch(fetchReturnCategoriesFailure(error));
      });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ReturnDetailContainer));
